import React from 'react';
import PropTypes from 'prop-types';

import { ConfirmModal, Space, Text } from '@cashfree-intl/coherent';
import CombinedModesNote from './CombinedModesNote';
import { INSTANT_TAT } from '../constants';

const ConfirmActivation = ({
  modalData,
  closeModal,
  enablePaymentMethodsSubmit,
}) => (
  <ConfirmModal
    title={`Enable ${modalData.display}`}
    confirmText="Confirm"
    onClose={closeModal}
    onConfirm={() => enablePaymentMethodsSubmit(modalData, true)}
    confirmBtnEvent={`Primary_Button_Enable_${modalData.display}_Confirm`}
    closeBtnEvent={`Link_Button_Enable_${modalData.display}_Cancel`}
    closeCrossEvent={`Enable_${modalData.display}_Icon_Close`}
  >
    <Space gap={2} direction="column">
      <Text variant="b14" color="bodyLight">
        <span className="text-dark w-600">{modalData.display}</span> payment
        mode will be activated{' '}
        {modalData.tat && modalData.tat.trim().toUpperCase() === INSTANT_TAT ? (
          'instantly'
        ) : (
          <>in a few days</>
        )}
        . A standard pricing of{' '}
        <span className="text-dark w-600">{modalData.tdr}</span> % is applicable
        per transaction.
      </Text>
      <CombinedModesNote
        combinedModes={modalData.combinedModes}
        inline={false}
      />
    </Space>
  </ConfirmModal>
);

ConfirmActivation.propTypes = {
  modalData: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
  enablePaymentMethodsSubmit: PropTypes.func.isRequired,
};

export default ConfirmActivation;
